import styles from './Divider.css'

const Divider = props => {
  return (
    <hr className={styles.Divider} />
  )
}

export default Divider
